export const urls = {
  subscription: {
    retrieve: () => "/pollux/v1/user-subscriptions/latest/",
    cancel: (userId: string) =>
      `/pollux/v1/user-subscriptions/${userId}/cancel/`,
    productGroup: (slug: string) => `/phoebus/v1/products/groups/${slug}/`,
    startFreeTrial: () => "/pyxis/v1/rules/trigger-event/",
    retrieveRuleExecutionDetails: (eventName: string) =>
      `/pyxis/v1/rules/events/${eventName}/execution-details/`,
  },
}
